import type { ToastOptions, ToastPosition } from 'react-toastify';

const DEFAULT_TOAST_POSITION: ToastPosition = 'bottom-left';

export const DEFAULT_TOAST_OPTIONS: ToastOptions = {
  position: DEFAULT_TOAST_POSITION,
};

export const DEFAULT_SUCCESS_DELAY: ToastOptions['delay'] = 100;
export const DEFAULT_ERROR_DELAY: ToastOptions['delay'] = 500;
